import type { ICurrentLocationService } from "@/data/services/CurrentLocationService";

import { TastierClient } from "@/app/TastierClient";

export class AppCurrentLocationService implements ICurrentLocationService {
    public getLocationId(): string | undefined {
        return TastierClient.context.currentAllocation?.locationId;
    }
}
